import { useContext } from 'react';
import { ReduxContext } from '../contexts/ReduxContext';

// ----------------------------------------------------------------------

const useRedux = () => useContext(ReduxContext);

export default useRedux;
